export default __webpack_public_path__ + "static/media/FalconStor.0b5ae243.png";